// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AlterationPage-module__headerTumorTypeSelection__3FkLc{width:400px;height:20%}.RRT__panel.AlterationPage-module__panel__3SQC8{border-width:1px 0 0;padding-left:0;padding-right:0}.AlterationPage-module__categoricalAltDescription__20Lfe{color:gray}.AlterationPage-module__categoricalAltDescription__20Lfe a{color:gray !important;text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"headerTumorTypeSelection": "AlterationPage-module__headerTumorTypeSelection__3FkLc",
	"panel": "AlterationPage-module__panel__3SQC8",
	"categoricalAltDescription": "AlterationPage-module__categoricalAltDescription__20Lfe"
};
module.exports = exports;
